var _rect, _rect2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "54px",
    viewBox: "0 0 52 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#222",
    x: 0,
    y: 15,
    width: 52,
    height: 39
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#222",
    opacity: 0.900000036,
    x: 3,
    y: 51,
    width: 46,
    height: 3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#C7C6C1",
    points: "26 13 49.5735685 12.2915037 49.5735685 51.2915037 26 52"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#C7C6C1",
    points: "26 13 49.5735685 12.2915037 49.5735685 51.2915037 26 52"
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    fill: "freeze",
    attributeName: "points",
    dur: "300ms",
    repeatCount: "indefinite",
    to: "26 13 44.372231 3.8589904 44.372231 42.8589904 26 52"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    fill: "freeze",
    attributeName: "fill",
    dur: "300ms",
    repeatCount: "indefinite",
    to: "#D9D8D2"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D9D8D2",
    points: "26 13 44.372231 3.8589904 44.372231 42.8589904 26 52"
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    fill: "freeze",
    attributeName: "points",
    dur: "300ms",
    repeatCount: "indefinite",
    to: "26 13 36.3883757 0.178966842 36.3883757 39.1789668 26 52"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    fill: "freeze",
    attributeName: "fill",
    dur: "300ms",
    repeatCount: "indefinite",
    to: "#EDECE6"
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#EDECE6",
    points: "26 13 36.3883757 0.178966842 36.3883757 39.1789668 26 52"
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    fill: "freeze",
    attributeName: "points",
    dur: "300ms",
    repeatCount: "indefinite",
    to: "26 13 30.3765696 0.292749915 30.3765696 39.2927499 26 52"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    fill: "freeze",
    attributeName: "fill",
    dur: "300ms",
    repeatCount: "indefinite",
    to: "#F2F1EB"
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#F2F1EB",
    points: "26 13 30.3765696 0.292749915 30.3765696 39.2927499 26 52"
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    fill: "freeze",
    attributeName: "points",
    dur: "300ms",
    repeatCount: "indefinite",
    to: "26 15 26 0.960355416 26 41.1230808 26 54"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    fill: "freeze",
    attributeName: "fill",
    dur: "300ms",
    repeatCount: "indefinite",
    to: "#F2F1EB"
  }))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#C7C6C1",
    points: "26 13 26 52 2.42643155 51.2915037 2.42643155 12.2915037"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D9D8D2",
    points: "26 13 26 52 7.62776902 42.8589904 7.62776902 3.8589904"
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    fill: "freeze",
    attributeName: "points",
    dur: "300ms",
    repeatCount: "indefinite",
    to: "26 13 26 52 2.42643155 51.2915037 2.42643155 12.2915037"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    fill: "freeze",
    attributeName: "fill",
    dur: "300ms",
    repeatCount: "indefinite",
    to: "#C7C6C1"
  }))), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#EDECE6",
    points: "26 13 26 52 15.6116243 39.1789668 15.6116243 0.178966842"
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    fill: "freeze",
    attributeName: "points",
    dur: "300ms",
    repeatCount: "indefinite",
    to: "26 13 26 52 7.62776902 42.8589904 7.62776902 3.8589904"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    fill: "freeze",
    attributeName: "fill",
    dur: "300ms",
    repeatCount: "indefinite",
    to: "#D9D8D2"
  }))), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#F2F1EB",
    points: "26 13 26 52 21.6234304 39.2927499 21.6234304 0.292749915"
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    fill: "freeze",
    attributeName: "points",
    dur: "300ms",
    repeatCount: "indefinite",
    to: "26 13 26 52 15.6116243 39.1789668 15.6116243 0.178966842"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    fill: "freeze",
    attributeName: "fill",
    dur: "300ms",
    repeatCount: "indefinite",
    to: "#EDECE6"
  }))), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#F2F1EB",
    points: "26 13 26 52 25.6234304 39.2927499 25.6234304 0.292749915"
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    fill: "freeze",
    attributeName: "points",
    dur: "300ms",
    repeatCount: "indefinite",
    to: "26 13 26 52 21.6234304 39.2927499 21.6234304 0.292749915"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.2ce7cdc8698315726ce285729ac19192.svg";
export { ForwardRef as ReactComponent };